

















































































import { AxiosError } from 'axios';
import { mapGetters } from 'vuex';
import { PropType } from 'vue';

import { updateStreamer, validateStreamer } from '@/api/CopyStake/Streamers';
import { TStreamer, EStreamerType, EStreamingType } from '@/api/schema';

import * as vr from '@/helpers/validation';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { objectToBlob } from '@/helpers/blobHelper';

export default {
  name: 'CopyStakeWebStreamerEditDialog',
  props: {
    value: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => false
    },
    streamer: {
      type: Object as PropType<TStreamer>,
      default: null
    }
  },
  data(): any {
    return {
      streamerTypes: [
        { value: EStreamerType.PRIVATE, label: 'Private' },
        { value: EStreamerType.PUBLIC, label: 'Public' }
      ],

      formData: {
        nickname: null,
        language: null,
        operatorUserId: '',
        accessCode: '',
        type: ''
      },

      serverError: {
        accessCode: null,
        operatorUserId: null,
        type: null,
        streamingType: null
      },

      processing: false,
      formValid: false
    };
  },
  watch: {
    async value(val: boolean): Promise<void> {
      if (val) {
        await this.resetForm();

        if (!!this.streamer && !!Object.keys(this.streamer).length) {
          this.formData = {
            ...this.streamer
          };
        }
      }
    }
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),
    isDialogVisible: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean): void {
        this.$emit('input', value);
      }
    },
    rules(): any {
      return {
        type: [vr.required],
        operatorUserId: [vr.required],
        accessCode: [
          (v: string) => {
            if (this.formData.type === EStreamerType.PRIVATE) {
              return vr.required(v);
            }

            return true;
          },
          (v: string) => {
            if (!v) return true;

            return !v.includes(' ') || 'No blank space available';
          },
          (v: string) => {
            if (!v) return true;

            return vr.validByRegExp(
              v,
              /^[0-9A-Z]{6}$/i,
              'Access code field must contains only numbers and A-Z'
            );
          },
          (v: string) => {
            if (!v) return true;

            return vr.minLength(v, 6);
          },
          (v: string) => {
            if (!v) return true;

            return vr.maxLength(v, 6);
          }
        ]
      };
    },
    isEdit(): boolean {
      return !!this.streamer?.id;
    },
    header(): string {
      return this.isEdit ? 'Edit Streamer' : 'New Streamer';
    },
    submitText(): string {
      return this.isEdit ? 'Save' : 'Next';
    }
  },
  methods: {
    async handlerOnSubmit(): Promise<void> {
      try {
        this.resetServerErrors();
        await this.$refs.form.validate();

        if (!this.formValid || this.processing) return;
        this.processing = true;

        const payload = {
          ...this.formData,
          accessCode:
            (this.formData.accessCode &&
              this.formData.accessCode.toUpperCase()) ||
            null,
          streamingType: EStreamingType.WEB,
          operatorId: this.operatorId
        };

        let streamerData: TStreamer;

        if (this.isEdit) {
          const formData = new FormData();

          formData.append('streamer', objectToBlob(payload));

          streamerData = await updateStreamer(this.streamer.id, formData);

          this.$toast.success(
            `Streamer "${streamerData.playerId}" has been successfully updated`
          );
        } else {
          await validateStreamer(payload);

          streamerData = payload;
        }

        this.closeDialog(this.isEdit);

        this.$emit('submit', {
          isEdit: this.isEdit,
          streamer: streamerData
        });
      } catch (error) {
        this.parseServerErrors(error);
        errorToastMessage(error);
      } finally {
        this.processing = false;
      }
    },
    parseServerErrors(error: AxiosError): void {
      if (error instanceof AxiosError) {
        const errorMessage = error.response?.data?.message;
        if (!errorMessage) return;

        if (
          errorMessage.includes('Streamer with access code') ||
          errorMessage.includes('Streamer with accessCode')
        ) {
          this.serverError.accessCode = errorMessage;
        }

        if (errorMessage.includes('Streamer with user')) {
          this.serverError.operatorUserId = errorMessage;
        }

        if (errorMessage.includes('User by operatorUserId')) {
          this.serverError.operatorUserId = errorMessage;
        }

        if (errorMessage.includes('streaming-type')) {
          this.serverError.streamingType = errorMessage;
        }
      }
    },
    closeDialog(clearData: boolean = true): void {
      this.isDialogVisible = false;
      this.$emit('close', clearData);
    },
    resetServerErrors(): void {
      this.serverError = {
        accessCode: null,
        operatorUserId: null,
        type: null,
        streamingType: null
      };
    },
    async resetForm(): Promise<void> {
      this.formData = {
        nickname: null,
        language: null,
        operatorUserId: '',
        accessCode: '',
        type: ''
      };

      this.resetServerErrors();
      await this.$refs.form?.reset();
    }
  }
};
